import $ from 'jquery';
$('.ikony__slick--1').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 6000,
    arrows: true,
    // prevArrow: "<div class='slick-prev pull-left'><img class='mainimg' src='/wp-content/themes/truskawka/assets/gfx/bector.svg' alt='arrow' /></div>",
    // nextArrow: "<div class='slick-next pull-right'><img class='mainimg' src='/wp-content/themes/truskawka/assets/gfx/bector.svg' alt='arrow' /></div>",
    swipeToSlide: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint:920,
          settings: {
            slidesToShow: 3,
            dots: true,
            arrows: false,
            slidesToScroll: 1,
          }
        }
      ]
});   

$('.sn__gallery').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    // prevArrow: "<div class='slick-prev pull-left'><img class='mainimg' src='/wp-content/themes/truskawka/assets/gfx/bector.svg' alt='arrow' /></div>",
    // nextArrow: "<div class='slick-next pull-right'><img class='mainimg' src='/wp-content/themes/truskawka/assets/gfx/bector.svg' alt='arrow' /></div>",
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
});   

var pagetitle1 = $(document).attr('title');
$('.sm__menuli').each(function(){
  var thisdata = $(this).data('curr');
  if (thisdata == pagetitle1){
    $(this).addClass("currlink");
  }
});